import Vue from "vue";
import VueRouter from "vue-router";
import DashboardPlugin from "./material-dashboard";

// Plugins
import App from "./App.vue";
import Chartist from "chartist";
import Notifications from './components/NotificationPlugin';
Vue.use(Notifications);

// router setup
import routes from "./routes/routes";

// store
import store from './store';

// i18n
import { i18n } from "@/plugins/i18n"

// plugin setup
Vue.use(VueRouter);
Vue.use(DashboardPlugin);

// Vuelidate
import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  mode: "history",
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  linkExactActiveClass: "nav-item active"
});

// global library setup
Vue.prototype.$Chartist = Chartist;

/* eslint-disable no-new */
window.mainApp = new Vue({
  el: "#app",
  render: h => h(App),
  router,
  store,
  i18n
});
